import React from 'react';
import Loading from './Loading';

/**
 * Backward-compat shim. Older components import `Spinner` — keep them working
 * while routing through the unified `<Loading>` primitive.
 * For new code prefer `<Loading variant="..." />` directly.
 */
const SIZE_BUCKETS = (px) => {
  if (px <= 14) return 'xs';
  if (px <= 18) return 'sm';
  if (px <= 28) return 'md';
  if (px <= 40) return 'lg';
  return 'xl';
};

const Spinner = ({ size = 20, className = '' }) => (
  <Loading variant="button" size={SIZE_BUCKETS(size)} className={className} />
);

export default Spinner;
